











import {Component, Vue} from "vue-property-decorator";

@Component({
    name: 'AppContent'
})
export default class Content extends Vue {
    get key() {
        return this.$route.path
    }
}
